var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo218(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#008696"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.17 12.9031L24.1 11.8331L18.55 17.3831V18.4631H19.63L25.17 12.9031ZM23 10.7331L24.29 9.44311C24.4286 9.30282 24.5936 9.19143 24.7756 9.11541C24.9576 9.03939 25.1528 9.00024 25.35 9.00024C25.5472 9.00024 25.7424 9.03939 25.9244 9.11541C26.1064 9.19143 26.2714 9.30282 26.41 9.44311L27.56 10.5931C28.15 11.1831 28.15 12.1331 27.56 12.7131L26.88 13.3931L26.86 13.4131L26.28 13.9931L20.28 19.9931H17V16.7331L23 10.7331ZM20.72 10.1831L20.17 10.7331L18.9 12.0031C15.6 12.0531 13 14.6031 13 18.2031C13 20.5431 14.95 23.6431 19 27.3431C23.05 23.6431 25 20.5531 25 18.2031V18.1031L26.8 16.3031C26.93 16.9031 27 17.5431 27 18.2031C27 21.5231 24.33 25.4531 19 30.0031C13.67 25.4531 11 21.5231 11 18.2031C11 13.2231 14.8 10.0031 19 10.0031C19.58 10.0031 20.16 10.0631 20.72 10.1831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo218);
export default __webpack_public_path__ + "static/media/logo218.c7dbf8c2aace8b8138c4d84787326bfa.svg";
export { ForwardRef as ReactComponent };